import { render } from "./rolesView.vue?vue&type=template&id=20ef5ad3&scoped=true"
import script from "./rolesView.vue?vue&type=script&lang=js"
export * from "./rolesView.vue?vue&type=script&lang=js"

import "./rolesView.vue?vue&type=style&index=0&id=20ef5ad3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ef5ad3"]])

export default __exports__